// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.unauthed-home-container-title{
 font-size: xx-large;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Unauthed/Pricing/Pricing.css"],"names":[],"mappings":";;AAEA;CACC,mBAAmB;AACpB","sourcesContent":["\n\n.unauthed-home-container-title{\n font-size: xx-large;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
